<template>
  <g>
    <g style="transform:scale(0.6)" @click="showDistance">
        <text transform="matrix(1 0 0 1 200 45)" class="name"
            >적외선센서{{ number }}</text
        >
        <path
            class="st0"
            d="M206.69,257v-27.13H217V162h-77.28v-17.56H98.83c-21.25,0-38.53-17.29-38.53-38.53s17.29-38.53,38.53-38.53
        h40.89V54h228.39v13.38h40.06c21.25,0,38.53,17.29,38.53,38.53s-17.29,38.53-38.53,38.53h-40.06V162H290v67.87h9V257H206.69z
        M274,229.87V162h-13v67.87H274z M245,229.87V162h-12v67.87H245z M409.84,95.11c-5.95,0-10.79,4.84-10.79,10.79
        c0,5.95,4.84,10.8,10.79,10.8s10.79-4.84,10.79-10.8C420.64,99.96,415.8,95.11,409.84,95.11z M98.83,95.11
        c-5.95,0-10.8,4.84-10.8,10.79c0,5.95,4.84,10.8,10.8,10.8c5.95,0,10.79-4.84,10.79-10.8C109.62,99.96,104.78,95.11,98.83,95.11z"
        />
        <rect x="142.72" y="57" class="st1" width="222.39" height="13.38" />
        <path
            class="st2"
            d="M408.17,70.38H98.83c-19.62,0-35.53,15.91-35.53,35.53v0c0,19.62,15.91,35.53,35.53,35.53h309.34
        c19.62,0,35.53-15.91,35.53-35.53v0C443.7,86.29,427.8,70.38,408.17,70.38z M98.83,119.7c-7.62,0-13.8-6.18-13.8-13.8
        c0-7.62,6.18-13.8,13.8-13.8c7.62,0,13.8,6.18,13.8,13.8C112.62,113.53,106.45,119.7,98.83,119.7z M409.84,119.7
        c-7.62,0-13.8-6.18-13.8-13.8c0-7.62,6.18-13.8,13.8-13.8c7.62,0,13.8,6.18,13.8,13.8C423.64,113.53,417.46,119.7,409.84,119.7z"
        />
        <rect x="142.72" y="82.08" class="st1" width="222.39" height="76.92" />
        <rect x="227.16" y="93.37" class="st3" width="137.95" height="54.34" />
        <g>
            <defs>
                <rect
                    id="SVGID_1_"
                    x="227.58"
                    y="93.37"
                    width="137.95"
                    height="54.34"
                />
            </defs>
            <clipPath id="SVGID_2_">
                <use xlink:href="#SVGID_1_" style="overflow:visible;" />
            </clipPath>
            <circle class="st4" cx="329.15" cy="120.56" r="31.75" />
        </g>
        <rect x="142.72" y="92.95" class="st3" width="54.34" height="54.34" />
        <g>
            <circle cx="169.48" cy="120.54" r="20.07" />
            <circle class="st5" cx="162.37" cy="113.43" r="4.6" />
        </g>
        <g>
            <circle cx="328.73" cy="120.14" r="20.07" />
            <circle class="st5" cx="321.63" cy="113.03" r="4.6" />
        </g>
        <g>
            <rect x="220" y="159" class="st6" width="10" height="74" />
        </g>
        <g>
            <rect x="277" y="159" class="st7" width="10" height="74" />
        </g>
        <g>
            <rect x="248" y="159" class="st8" width="10" height="74" />
        </g>
        <rect x="209.69" y="232.87" class="st9" width="86.31" height="21.13" />
        <!-- terminal -->
        <g class="pin">
            <rect x="220.5" y="237" class="st10" width="11" height="11" />
            <rect
                :id="`${pincode}SG`"
                @click="onClick(`${pincode}SG`)"
                x="216"
                y="237"
                class="pin-cover terminal"
                width="18"
                height="18"
            />
            <text transform="matrix(1 0 0 1 205 300)" class="pin-name"
                >SIG</text
            >
        </g>
        <g class="pin">
            <rect x="248.5" y="237" class="st10" width="11" height="11" />
            <rect
                :id="`${pincode}MS`"
                @click="onClick(`${pincode}MS`)"
                x="244"
                y="237"
                class="pin-cover terminal"
                width="18"
                height="18"
            />
            <text transform="matrix(1 0 0 1 225 300)" class="pin-name"
                >GND</text
            >
        </g>
        <g class="pin">
            <rect x="277.5" y="237" class="st10" width="11" height="11" />
            <rect
                :id="`${pincode}PS`"
                @click="onClick(`${pincode}PS`)"
                x="273"
                y="237"
                class="pin-cover terminal"
                width="18"
                height="18"
            />
            <text transform="matrix(1 0 0 1 255 300)" class="pin-name"
                >VCC</text
            >
        </g>
        <g id="inf-distance">
            <path
                id="inf-distance-area"
                style="transform: translate(0px, 100px) rotate(-90deg)"
                :class="{ 'dist-st1': on, 'dist-st0': !on }"
                d="M448,264c0-61.54-12.13-121.43-36.05-177.99c-6.17-14.58-13.05-28.76-20.62-42.51L94.31,209.04
            C103.04,225.43,108,244.13,108,264s-4.96,38.57-13.69,54.96L391.33,484.5c7.57-13.75,14.45-27.92,20.62-42.51
            C435.87,385.43,448,325.54,448,264z"
            />
            <g class="infrared-picker">
                <text
                    transform="matrix(1 0 0 1 230 -190)"
                    :class="{ 'dist-st0': !on }"
                    style="font-size: 26px; fill: black;"
                >
                    {{ distance === 0 ? "클릭하여 드래그" : distance + "cm" }}
                </text>
                <circle
                    :class="{ st19: on, 'dist-st0': !on }"
                    cx="270"
                    cy="-150"
                    r="31.5"
                />
            </g>
        </g>
    </g>
  </g>
</template>

<script>
import Vue from 'vue'
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

const calDistance = function (coord) {
  const origin = {
    x: -7,
    y: 124
  }
  const dist =
        (origin.x - coord.x) * (origin.x - coord.x) +
        (origin.y - coord.y) * (origin.y - coord.y)
  return Math.round(dist) / 1000 + 10
}

var vm = new Vue({
  socket: null,
  data: {
    dist: 0,
    x: 0,
    y: 0
  }
})

export default {
  props: ['data'],
  mixins: [pins],
  name: 'InfraredSensor',
  data () {
    return {
      draggable: null,
      on: false,
      mouse: {
        x: 0,
        y: 0
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  computed: {
    distance () {
      return vm.dist
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      vm.socket = socket
      this.on = true
      this.showDistance()
    },
    off () {
      vm.socket = null
      this.on = false
      window.Draggable.get(`#${this.data.id}`).enable()
    },
    showDistance () {
      if (this.on) {
        window.Draggable.get(`#${this.data.id}`).disable()
        var id = this.data.id
        this.draggable = window.Draggable.create(`#${id} .infrared-picker`, {
          bounds: `#${id} #inf-distance`,
          onDragEnd: function () {
            if (this.hitTest(`#${id} #inf-distance-area`, '10%')) {
              document.querySelector(`#${id} .infrared-picker circle`).classList.add('st20')
              vm.dist = calDistance({ x: this.x, y: this.y })
              if (vm.dist > 80.0) vm.dist = 80.0
              store.commit('socket/sendMessage', { socket: vm.socket, message: { value: vm.dist } })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin-name {
    display: none;
    font-size: 28px;
}

.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
    .pin-name {
        display: block;
    }
}
.selected {
    & path.st0 {
        fill: #ff6f61;
        display: block;
    }
}
.name {
    font-size: 24px;
}
.st0 {
    fill: #d6d6d6;
    display: none;
}
.st1 {
    fill: #646464;
}
.st2 {
    fill: #333333;
}
.st3 {
    fill: #515151;
}
.st4 {
    clip-path: url(#SVGID_2_);
    fill: none;
    stroke: #282828;
    stroke-miterlimit: 10;
}
.st5 {
    fill: #cccccc;
}
.st6 {
    fill: #efc488;
}
.st7 {
    fill: #bf5a3e;
}
.st8 {
    fill: #564c3e;
}
.st9 {
    fill: #3d3c44;
}
.st10 {
    stroke: #575058;
    stroke-width: 2;
    stroke-miterlimit: 10;
}
.st19 {
    fill: #3d3c44;
}
.st21 {
    font-family: "Noto Sans KR", sans-serif;
}
.dist-st0 {
    display: none;
    fill: none;
}
.dist-st1 {
    display: block;
    fill: #ff6f61;
}
</style>
